'use client';

import { useState, useEffect } from 'react';
import { useFirestore } from '@/firebase';
import { doc, getDoc } from 'firebase/firestore';
import { MarkdownContent } from '@/components/ui/markdown-content';
import { Skeleton } from '@/components/ui/skeleton';

// Default fallback content
const DEFAULT_HISTORY = `SRAC was founded in 1953 as the Seattle Radio Aero Club with a flying field at what is now Magnuson Park at Sand Point on Lake Washington.

When this original field became unavailable, SRAC leased a flying site near the Arlington Airport from 1959 through 1966. In 1967, we moved to our current 25 acre site and later changed the name to Snohomish Radio Aero Club.`;

export function ClubHistory() {
  const firestore = useFirestore();
  const [history, setHistory] = useState<string>(DEFAULT_HISTORY);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    async function fetchHistory() {
      try {
        const historyDoc = await getDoc(doc(firestore, 'membershipInfo', 'clubHistory'));

        if (historyDoc.exists()) {
          const data = historyDoc.data();
          if (data?.value) {
            setHistory(data.value);
          }
        }
      } catch (error) {
        console.error('Error fetching club history:', error);
        // Keep using the default history
      } finally {
        setIsLoading(false);
      }
    }

    fetchHistory();
  }, [firestore]);

  if (isLoading) {
    return (
      <div className="space-y-3">
        <Skeleton className="h-4 w-full" />
        <Skeleton className="h-4 w-full" />
        <Skeleton className="h-4 w-3/4" />
        <Skeleton className="h-4 w-full mt-4" />
        <Skeleton className="h-4 w-5/6" />
      </div>
    );
  }

  return <MarkdownContent content={history} />;
}
